export default __webpack_public_path__ + "static/media/Camion3.f984801a.png";